import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import React from 'react';
import types from 'prop-types';
import { addEventListener, removeEventListener } from 'consolidated-events';
var propTypes = process.env.NODE_ENV !== "production" ? {
  children: types.node,
  onOutsideClick: types.func
} : {};
var defaultProps = {
  onOutsideClick: function onOutsideClick() {}
};

var OutsideClickHandler =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OutsideClickHandler, _React$Component);

  function OutsideClickHandler(props) {
    var _this;

    _classCallCheck(this, OutsideClickHandler);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OutsideClickHandler).call(this, props));
    _this.onOutsideClick = _this.onOutsideClick.bind(_assertThisInitialized(_this));
    _this.bindClickListener = _this.bindClickListener.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OutsideClickHandler, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.bindClickListener, 100);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.clickHandle) removeEventListener(this.clickHandle);
    }
  }, {
    key: "bindClickListener",
    value: function bindClickListener() {
      this.clickHandle = addEventListener(document, 'click', this.onOutsideClick, {
        capture: true
      });
    }
  }, {
    key: "onOutsideClick",
    value: function onOutsideClick(e) {
      if (!this.childNode || !this.childNode.contains(e.target)) {
        this.props.onOutsideClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        ref: function ref(_ref) {
          _this2.childNode = _ref;
        }
      }, this.props.children);
    }
  }]);

  return OutsideClickHandler;
}(React.Component);

export { OutsideClickHandler as default };
OutsideClickHandler.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
OutsideClickHandler.defaultProps = defaultProps;